export default "__VITE_ASSET__faed0b9e__"